<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong
                    >{{ partner.title }}: {{ discount_card.title }}</strong
                    >
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <PartnerDiscountCardTabLinks />
                        <CDataTable
                            hover
                            column-filter
                            sorter
                            striped
                            :items="clients"
                            :fields="fields"
                            :items-per-page="10"
                            :active-page="activePage"
                            :pagination="{ doubleArrows: true, align: 'center' }"
                            clickable-rows
                            @page-change="pageChange"
                            @row-clicked="rowClicked"
                        >
                            <template #phone="data">
                                <td>
                                    <strong>{{ data.item.phone }}</strong>
                                </td>
                            </template>
                            <template #name="data">
                                <td>{{ data.item.name ? data.item.name : "" }}</td>
                            </template>
                            <template #enabled="data">
                                <td>
                                    <CBadge
                                        :color="getBadge(data.item.enabled)"
                                    >&nbsp;{{
                                        data.item.enabled ? "Да" : "Нет"
                                    }}&nbsp;</CBadge
                                    >
                                </td>
                            </template>
                        </CDataTable>
                    </template>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="showCreateModal"
                    >Создать</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            :title="`${modal.title}`"
            :show.sync="modal.show"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Имя
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="modal.client.name" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Телефон
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="modal.client.phone" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="light"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="modal.client.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="save">{{
                            modal.buttonText
                        }}</CButton>
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="modal.show = false"
                    >Отмена</CButton
                    >
                    <CButton
                        v-if="modal.client.id"
                        color="danger"
                        class="ml-3"
                        @click="deleteClient"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnerDiscountCardTabLinks from '@/components/partner/PartnerDiscountCardTabLinks';

    export default {
        name: 'DiscountCardClients',

        components: {
            PartnerDiscountCardTabLinks,
        },

        data() {
            return {
                loading: true,
                partner: {},
                discount_card: {},
                clients: [],
                fields: [
                    {
                        key: 'phone',
                        label: 'Телефон',
                        _classes: 'font-weight-bold',
                    },
                    { key: 'name', label: 'Имя' },
                    { key: 'enabled', label: 'Активен' },
                ],
                activePage: 1,
                modal: {
                    title: 'Создать клиента',
                    show: false,
                    buttonText: 'Создать',
                    client: {
                        id: null,
                        name: '',
                        phone: '',
                        enabled: true,
                    },
                },
            };
        },

        computed: {},

        async mounted() {
            const partnerId = parseInt(this.$route.params.id);
            const discountCardId = parseInt(this.$route.params.discount_card_id);
            await Vue.axios
                .get('/partners/' + partnerId)
                .then(resp => {
                    this.partner = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios
                .get('/discount-cards/' + discountCardId)
                .then(resp => {
                    this.discount_card = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios
                .get('/discount-cards/' + discountCardId + '/clients')
                .then(resp => {
                    this.clients = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            this.loading = false;
        },

        methods: {
            showCreateModal() {
                this.modal.title = 'Создание клиента';
                this.modal.client = {
                    id: null,
                    name: '',
                    phone: '',
                    enabled: true,
                };
                this.modal.buttonText = 'Создать';
                this.modal.show = true;
            },

            rowClicked(item) {
                this.modal.title = 'Редактирование клиента';
                item.enabled = item.enabled ? true : false;
                this.modal.client = item;
                this.modal.buttonText = 'Сохранить';
                this.modal.show = true;
            },

            deleteClient() {
                // ToDo
                Vue.axios
                    .delete(
                        '/discount-cards/' +
                            this.discount_card.id +
                            '/clients/' +
                            this.modal.client.id
                    )
                    .then(resp => {
                        // Nothing to do
                        this.reloadClients();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            save() {
                this.modal.client.enabled = this.modal.client.enabled
                    ? true
                    : false;
                this.modal.client.discount_card_id = this.discount_card.id;
                this.modal.client.discount = parseInt(this.modal.client.discount);
                if (this.modal.client.id) {
                    // Update
                    Vue.axios
                        .put(
                            '/discount-cards/' +
                                this.discount_card.id +
                                '/clients/' +
                                this.modal.client.id,
                            this.modal.client
                        )
                        .then(resp => {
                            // Nothing to do
                            this.reloadClients();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                } else {
                    // Create
                    Vue.axios
                        .post(
                            '/discount-cards/' + this.discount_card.id + '/clients',
                            this.modal.client
                        )
                        .then(resp => {
                            // Nothing to do
                            this.reloadClients();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка создания.');
                        });
                }
            },

            reloadClients() {
                Vue.axios
                    .get('/discount-cards/' + this.discount_card.id + '/clients')
                    .then(resp => {
                        this.clients = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
                this.modal.show = false;
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },

            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
        },
    };
</script>
<style scoped>
</style>
